import _ from 'lodash';
import API from '../app/api';
import APIForm from '../app/apiForm';
import {prepareData} from '../pages/ward/forms/ecs/ecs';

export const generatePdf = async (piw, patientAddData, template, customData) => {
    let addData = patientAddData;

    if (addData === null)
        addData = await API.getPatientAdditionalData(piw?.patient?.__id);

    let data = await prepareData(piw, addData, template);
    if (customData) data = _.merge(data, customData);

    const openBlob = async (blobT) => {
        let blob = new Blob([blobT], {type: 'application/pdf'});
        let objectURL = window.URL.createObjectURL(blob);
        window.open(objectURL, '_blank');
    };

    return APIForm.getFormPdf({data})
        .then((response) => {
                if (response) openBlob(response);
                return response;
            },
            (er) => {
                console.error(er);
                return false;
            },
        );
};